export const generativeAiAppGroupIdStandardsRulesetSynthesis =
  "/:app_group_id/generative_ai/standards_ruleset_synthesis";
